import { useMutation, useQueryClient } from '@tanstack/react-query';
import { authService } from '../services/authService';

export function useLogout() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: () => authService.logout(),
    onSuccess: () => {
      qc.clear();
      window.location.replace('/login');
    },
  });
}
